import {useEffect} from 'react';

/**
 * Lazy load videos by using the IntersectionObserver API
 * It will load the video when it is in the viewport to improve performance
 * But the video element references can broke if react changes how they are rendered
 * maybe we need a new approach to use Refs instead of querySelector
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * @see https://web.dev/lazy-loading-video/
 */
export function LazyLoadVideos() {
  useEffect(() => {
    const lazyVideos = [...document.querySelectorAll('video.lazy')];

    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((video) => {
          if (video.isIntersecting) {
            for (const source in video.target.children) {
              const videoSource = video.target.children[
                source
              ] as HTMLSourceElement;

              if (
                typeof videoSource.tagName === 'string' &&
                videoSource.tagName === 'SOURCE' &&
                videoSource.dataset.src
              ) {
                videoSource.src = videoSource.dataset.src;
              }
            }

            (video.target as HTMLVideoElement).load();
            video.target.classList.remove('lazy');
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });

      lazyVideos.forEach((lazyVideo) => {
        lazyVideoObserver.observe(lazyVideo);
      });

      return () => {
        lazyVideoObserver.disconnect();
      };
    }
  }, []);

  return null;
}
